// const headers = {
//   name: "Expenses",
//   components: [
//     {
//       type: "search",
//       name: "search",
//       placeholder: "Search",
//       value: "",
//     },
//     {
//       type: "select",
//       name: "sort",
//       placeholder: "Sort",
//       value: null,
//       options: [
//         { value: "1", label: "Amount (Low)" },
//         { value: "2", label: "Amount (High)" },
//       ],
//     },
//     {
//       type: "filter",
//       name: "category",
//       placeholder: "Category",
//       allowClear: true,
//       showSearch: true,
//       filterOption: false,
//       api: "get-all-expense-categories",
//       value: null,
//       options: null,
//     },
//     {
//       type: "range",
//       name: "date",
//       value: {
//         start: "",
//         end: "",
//       },
//     },
//     {
//       type: "add",
//       path: "/app/expenses/add",
//     },
//   ],
//   navigate: {
//     tabs: [
//       {
//         name: "Expenses",
//         path: "",
//       },
//       {
//         name: "Categories",
//         path: "/app/expenses/categories",
//       },
//     ],
//     total: [
//       { value: "0", label: "Total" },
//       { value: "0", label: "Active" },
//       { value: "0", label: "Inactive" },
//     ],
//   },
// };

// export default headers;


const headers = {
  name: "Expenses",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by number or description",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort By",
      value: "0",                    // Default = Newest First
      options: [
        { value: "0", label: "Newest First" },
        { value: "1", label: "Oldest First" },
        { value: "2", label: "Amount (Low to High)" },
        { value: "3", label: "Amount (High to Low)" },
      ],
    },
    {
      type: "filter",
      name: "category",
      placeholder: "Category",
      allowClear: true,
      showSearch: true,
      filterOption: true,           // Changed to true (better)
      api: "get-all-expense-categories",
      value: null,
      options: null,
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/expenses/add",
    },
  ],
  navigate: {
    tabs: [
      { name: "Expenses", path: "" },
      { name: "Categories", path: "/app/expenses/categories" },
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
};

export default headers;